import { useRef } from "react";
import { clsxm } from "../../../utils/clxm/clxm";
import { ArrowDownIcon } from "./icons/ArrowDownIcon";
import { Option } from "./MultiSelect";

export const MultiSelectLabel = ({
  selectedValues,
  options,
  color,
  baseColor,
  expanded,
  borderColor,
  expandedBorderColor,
}: {
  selectedValues: (string | number)[];
  options: Option[];
  color?: string;
  baseColor?: string;
  expanded: boolean;
  borderColor?: string;
  expandedBorderColor?: string;
}) => {
  const selectedLabels = selectedValues
    .map((val) => options.find((option) => option.value === val)?.label)
    .filter(Boolean);

  const fieldRef = useRef<HTMLElement | null>(null);

  return (
    <div
      className={clsxm(
        `flex flex-row justify-between items-center`,
        expanded
          ? `border-t border-l border-r border-b-0 border-${expandedBorderColor} rounded-[8px_8px_0px_0px]`
          : `border-[1px] border-${borderColor} rounded-[8px]`,
        "px-[10px] bg-" + (expanded ? color : baseColor),
      )}
      style={{
        boxShadow: expanded
          ? "0px 4px 16px 0px rgba(0, 89, 127, 0.32)"
          : "none",
        height: fieldRef.current?.clientHeight,
        minHeight: "48px",
      }}
    >
      <div className="w-full text-text-base text-[12px] font-normal text-left flex flex-wrap items-center gap-1 py-[6px] overflow-hidden max-h-24">
        {selectedLabels.length > 0 ? (
          selectedLabels.map((label, index) => (
            <span key={index} className="flex items-center whitespace-nowrap">
              {label}
              {index < selectedLabels.length - 1 && <span>&nbsp;,&nbsp;</span>}
            </span>
          ))
        ) : (
          <span className="text-[12px] text-text-base font-normal">
            Select items
          </span>
        )}
      </div>
      <ArrowDownIcon className={expanded ? "rotate-180" : "rotate-0"} />
    </div>
  );
};
